import { defineComponent as _defineComponent } from 'vue'
import { useIntroductionDialogStore } from '@/stores/introductionDialog'


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroductionRequestForm',
  emits: ["submit"],
  setup(__props) {



const store = useIntroductionDialogStore()

return { __sfc: true,store }
}

})